import { styled } from 'goober';
import { COLORS } from '../../config/colors/colors';
import { TextAlign, TypographySizeParams } from './types';

export const Text = styled('span')<{ $font: TypographySizeParams; $color: keyof typeof COLORS; $align: TextAlign }>`
    ${({ $font, $color, $align }) => `
        font-size: ${$font.size};
        font-weight: ${$font.weight};
        line-height: ${$font.lineHeight};
        ${$color && `color: ${COLORS[$color]};`}
        ${$align && `text-align: ${$align};`}
    `}
    white-space: pre-wrap;
    word-break: break-word;
`;
